export interface AuthenticationResult {
  readonly redirectUrl?: string;
  readonly newState?: string;
  readonly reload?: boolean;
}

export class AuthenticationResultFailure implements AuthenticationResult {
  constructor(public readonly redirectUrl?: string, public readonly newState?: string) {
  }
}

export class AuthenticationResultSuccess implements AuthenticationResult {
  constructor(public readonly newState?: string, public readonly reload?: boolean) {
  }
}
